import { set } from 'immutadot'
import {
    LOCK_LEFT_ASIDES,
    TOGGLE_BOTTOM_ASIDE,
    UNLOCK_LEFT_ASIDES,
    ZOOM_ASIDE_NAME,
} from './actions'
import {
    JUMP_TO_MEDIA,
    PREVIOUS_MEDIA,
    NEXT_MEDIA,
    JUMP_TO_GROUP,
    PREVIOUS_GROUP,
    NEXT_GROUP,
} from '../navigation/actions'
import {
    RESET,
    LOCK,
    ROTATE_RIGHT,
    ROTATE_LEFT,
} from '../appliedFilters/actions'
import { MINIMAP_INTERACTION } from '../minimap/actions'

export const aside = (state = {
    leftToolbar: {
        lockedBy: null,
    },
    bottomToolbar: {
        activeAside: null,
    }
}, action) => {
    switch (action.type)
    {
        case RESET:
        case LOCK:
        case ROTATE_LEFT:
        case ROTATE_RIGHT:
        case JUMP_TO_MEDIA:
        case PREVIOUS_MEDIA:
        case NEXT_MEDIA:
        case JUMP_TO_GROUP:
        case PREVIOUS_GROUP:
        case NEXT_GROUP:
            return {
                ...state,
                bottomToolbar: {
                    activeAside: null,
                }
            }

        case TOGGLE_BOTTOM_ASIDE:
            if(state.bottomToolbar.activeAside === action.asideName)
            {
                return {
                    ...state,
                    bottomToolbar: {
                        activeAside: null,
                    }
                }
            }

            return {
                ...state,
                bottomToolbar: {
                    activeAside: action.asideName
                }
            }

        case MINIMAP_INTERACTION:
            if(state.bottomToolbar.activeAside === null)
            {
                return aside(state, {type: TOGGLE_BOTTOM_ASIDE, asideName: ZOOM_ASIDE_NAME})
            }

            return state

        case LOCK_LEFT_ASIDES:
            return set(state, 'leftToolbar.lockedBy', action.lockedBy)

        case UNLOCK_LEFT_ASIDES:
            return set(state, 'leftToolbar.lockedBy', null)

        default:
            return state
    }
}
